<template>
    <div class="top-posts-slider lg:overflow-hidden">
        <div class="swiper-wrapper flex flex-row gap-2 lg:gap-4" ref="wrapper">
            <TradingRoomPostItem
                v-for="item in items"
                :key="item.id"
                ref="slide"
                class="bg-white shadow-md rounded-md transition-all ease-in-out duration-500"
                :class="[activeTopPost === item.id ? 'lg:w-2/5' : 'lg:w-1/5', slideClasses]"
                :active="activeTopPost === item.id"
                @mouseover="$emit('update:activeTopPost', item.id)"
                height="600px"
                layout="big_image_tags"
                :contentstream="item"
            />
        </div>
    </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

export default {
    props: ['items', 'activeTopPost'],

    emits: ['update:activeTopPost'],

    data: () => ({
        slider: null,
        listener: null,
        breakpoint: null,
        slideClasses: null
    }),
    methods: {
        breakpointChecker() {
            if (this.breakpoint.matches === true) {
                this.$refs.wrapper.classList.remove('swiper-wrapper');
                this.$refs.wrapper.classList.add('flex', 'flex-row', 'gap-4');
                this.slideClasses = null;

                if (this.slider !== null) {
                    this.slider.destroy(true, true);
                }
                return;
            } else if (this.breakpoint.matches === false) {
                this.$refs.wrapper.classList.add('swiper-wrapper');
                this.$refs.wrapper.classList.remove('flex', 'flex-row', 'gap-4');
                this.slideClasses = 'swiper-slide';

                this.slider = new Swiper('.top-posts-slider', {
                    slidesPerView: 1,
                    loop: true,
                    grabCursor: true
                });
            }
        }
    },
    mounted() {
        this.breakpoint = window.matchMedia(`(min-width:${this.$tw.theme.screens.lg})`);

        this.breakpointChecker();

        window.addEventListener('resize', this.breakpointChecker);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.breakpointChecker);
    }
};
</script>
